import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {

    public list: any;
    public pageMeta:any;
    public expand: false;
    public fields: any = {};
    public selectedRows: Array<any>;
    public selectedRowKeys: Array<string>;
    public App: any;
    public additionalList: Array<any>;
    public additionalListSingle: Array<any>;
    public fresh:string;
}


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceManage/Modules.State.ts